import { Component } from '@angular/core';
import { FileManagerComponent } from '../../../components/pages/file-manager/file-manager.component';

@Component({
  selector: 'app-sales-file-manager',
  imports: [FileManagerComponent],
  templateUrl: './sales-file-manager.component.html',
  styleUrl: './sales-file-manager.component.scss'
})
export class SalesFileManagerComponent {
  initialPath: string = 'sales';
}
